module.exports = __webpack_public_path__ + "static/media/newTopBackGround.0d858a3b.jpg";